import styled from "styled-components";

import { c, v } from "constants/css";

export const ModalDescription = styled.p`
  font-size: ${v.smallFontSize};
  color: ${c.colorGrey4Active};
`;
